exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-map-text[data-v-a8e6afea]{bottom:5px}", ""]);

// exports
